import { combineReducers } from 'redux';
import UIReducer from './UIReducer';
import StartAppReducer from './StartApp.Reducer';
import SearchFieldReducer from './SearchFieldReducer';
import SearchParameterReducer from './SearchParameter.Reducer';
import EvaluationReducer from './EvaluationReducer';

const RootReducer = combineReducers({
  UI: UIReducer,
  StartApp: StartAppReducer,
  SearchField: SearchFieldReducer,
  SearchParameter: SearchParameterReducer,
  Evaluation: EvaluationReducer
});

export default RootReducer;



// WEBPACK FOOTER //
// ./src/reducers/RootReducer.js